import { sendDwh } from 'reactApp/utils/ga';

export const sendStoryWidgetDwh = ({ action, eventCategory = 'story-section', ...data }): void => {
    sendDwh({ eventCategory, action, dwhData: data });
};
